
import React from 'react';
import { JUVCard } from '@/components/juv';
import { Sparkle } from 'lucide-react';
import TreatmentTable from './TreatmentTable';

const SignatureBundlesSection = () => {
  const bundles = [
    {
      name: 'Bright Eyes',
      price: '$699 ($899 value)',
      benefits: 'SmoothEye + PRP Under-Eye + 20u Xeomin'
    },
    {
      name: 'Youth Refresh',
      price: '$1,399',
      benefits: 'Xeomin (50u Full Face) + RF Microneedling w/ PRP'
    },
    {
      name: 'Natural Lip Duo',
      price: '$300',
      benefits: 'LipLase + Lip Flip'
    },
    {
      name: 'Hair Refresh',
      price: '$799/session or $1,499/3',
      benefits: 'PRP Hair Restoration w/ Laser'
    }
  ];

  return (
    <JUVCard
      title="🌟 Signature Bundles"
      icon={Sparkle}
      variant="luxury"
      className="mb-8"
      glowEffect={true}
    >
      <TreatmentTable
        headers={['Package', "What's Included", 'Price']}
        treatments={bundles.map(bundle => ({
          name: bundle.name,
          benefits: bundle.benefits,
          price: bundle.price
        }))}
      />
    </JUVCard>
  );
};

export default SignatureBundlesSection;
